import { ContextStore } from './ContextStore';

export default ContextStore;
